import { Pipe, PipeTransform, inject } from '@angular/core';
import { MonNumberService } from '@monsido/core/locale/services/mon-number.service';

@Pipe({
    name: 'monNumber',
    standalone: true,
})
export class MonNumberPipe implements PipeTransform {
    private readonly monNumberService = inject(MonNumberService);

    transform (value: number | string | null | undefined, format: string = ''): string {
        const numValue = Number(value);
        if (Number.isNaN(numValue)) {
            return String(value ?? '');
        }
        if (!format) {
            return this.monNumberService.transformNumber(numValue);
        }
        if (format.toString().length < 2) {
            return this.monNumberService.transformNumber(numValue, `0,0`);
        }
        return this.monNumberService.transformNumber(numValue, format);
    }
}
